import { Platform } from '../interfaces/entities/platform'

export const platformsMocked: Platform[] = [
  {
    value: 'facebook',
    label: 'Facebook',
  },
  {
    value: 'performance_advertising',
    label: 'PIA Advertising',
  },
]
